import { ContentState, EditorState, Modifier } from 'draft-js';
import detectFollowupEntity from '../utils/detectFollowupEntity';
import { pipe } from '@repo/utils/helpers/operators';

export default function forgetFollowup(editorState: EditorState): EditorState {
  const currentSelectionState = editorState.getSelection();
  const contentStateWithSkipParsingEntity = editorState
    .getCurrentContent()
    .createEntity('skipFollowupParsing', 'MUTABLE');
  const entityKey = contentStateWithSkipParsingEntity.getLastCreatedEntityKey();
  const [_, followupEntityState] = detectFollowupEntity(editorState);

  // If we get a mismatch where we've stored a reminder for a note but that
  // reminder has no corresponding entity in content
  if (!followupEntityState.exists || followupEntityState.offset == -1) {
    return editorState;
  }

  const followupSelection = currentSelectionState.merge({
    anchorOffset: followupEntityState.offset,
    focusOffset: followupEntityState.endIndex,
    anchorKey: followupEntityState.blockKey,
    focusKey: followupEntityState.blockKey,
  });

  const newEditorState = pipe(
    (cs: ContentState) => Modifier.applyEntity(cs, followupSelection, null),
    (cs: ContentState) => Modifier.applyEntity(cs, followupSelection, entityKey),
    (cs: ContentState) => EditorState.push(editorState, cs, 'insert-fragment'),
  )(contentStateWithSkipParsingEntity);

  return EditorState.forceSelection(newEditorState, currentSelectionState);
}
